export default __webpack_public_path__ + "static/media/royal_esplanade_1k.a1d22329.hdr";